import {
  IUserAvatarController,
  MK_USER_AVATAR_INPUT_CONFIG,
} from "./IUserAvatarController";
import {AbstractController} from "../../../controllers/AbstractController";
import {effect, inject, signal} from "@angular/core";
import {ControllerEventBus} from "../../../event-buses/controller.event-bus";
import {User} from "../../../interfaces/rest/User";
import {UserSessionRepository} from "../../../repositories/user-session.repository";
import {UserRepository} from "../../../repositories/user.repository";
import {UserAvatarInputConfigModel} from "../_models/UserAvatarInputConfigModel";



export abstract class AbstractUserAvatarController extends AbstractController implements IUserAvatarController {


  protected readonly userSessionRepository = inject(UserSessionRepository);
  protected readonly userRepository =  inject(UserRepository);

  protected  configModel : UserAvatarInputConfigModel | undefined = undefined;

  protected userId: number | undefined;


  protected constructor() {
    super();
    this.initModels();
  }

  protected initModels() {
    this.addModel(MK_USER_AVATAR_INPUT_CONFIG, {
      avatar$ :signal(this.isDefaultAvatar()),
      firstName$ :signal(this.isDefaultFirstName()),
      lastName$ :signal(this.isDefaultLastName()),
      userId$ :signal(this.isDefaultUserId()),
      isSee$: signal(this.isDefaultisSee()),
      userRoles$: signal(this.isDefaultUserRoles()),
      enableTooltip$:signal(this.isDefaultEnableTooltip()),
      userType$: signal(this.isDefaultUserType()),
      userInitials$ :  signal(this.isDefaultUserInitials()),
      size$ : signal(this.isDefaultSize()),
    });

  }


  protected initialize() {
    if (!this.configModel?.avatar$() && !this.configModel?.userId$()) {
      this.configModel?.userId$.set(this.userSessionRepository.getUserSession()?.userId!)
    }
    if (this.configModel?.userId$() ) {

      this.userRepository.getUser(this.configModel?.userId$()).subscribe({
        next: (user) => {
          if (user.profileImage && user.profileImage.fileURL) {
            this.configModel?.avatar$.set(user.profileImage.fileURL);
          }

          this.configModel?.firstName$.set(user.firstName!);
          this.configModel?.lastName$.set(user.lastName!);
          this.configModel?.firstName$.set(user.firstName!);

          this.configModel?.isSee$.set(user.isSee!);
          this.configModel?.userRoles$.set([User.getRoleKey(user)]);

          this.initializeAvatar();

        },
        error: (error) => {
          this.configModel?.firstName$.set('Unknown');
          this.configModel?.lastName$.set('User');
          this.configModel?.isSee$.set(false);
          this.configModel?.userRoles$.set(['']);
          this.initializeAvatar();
        }
      })
    }
  }




  initializeAvatar() {

    const currentUser = this.userSessionRepository.getUserSession();
    if(this.configModel?.firstName$() && this.configModel?.lastName$()) {
      this.configModel?.userInitials$.set(this.createUserInitials(this.configModel?.firstName$(), this.configModel?.lastName$()));
    }
    else {
      this.configModel?.userInitials$.set(this.createUserInitials(currentUser?.firstName!, currentUser?.lastName!));
    }

    if(this.configModel?.isSee$() !== null && this.configModel?.isSee$()  !== undefined && this.configModel?.userRoles$() !== null && this.configModel?.userRoles$() !== undefined) {
      this.configModel?.userType$.set(this.resolveUserType(this.configModel?.isSee$()!, this.configModel?.userRoles$()!));
    }
    else {
      this.configModel?.userType$.set(this.resolveUserType(currentUser?.userType === 'see', currentUser?.roles!));
    }

  }

  handleConfigOverwrite(eventData: any): void {
    this.configModel = this.getModel(MK_USER_AVATAR_INPUT_CONFIG);
    if(eventData['avatar'] !== null && eventData['avatar'] !== undefined) {
      this.configModel?.avatar$.set(eventData['avatar']);
    }
    if(eventData['firstName'] !== null && eventData['firstName'] !== undefined) {
      this.configModel?.firstName$.set(eventData['firstName']);
    }
    if(eventData['lastName'] !== null && eventData['lastName'] !== undefined) {
      this.configModel?.lastName$.set(eventData['lastName']);
    }
    if(eventData['userId'] !== null && eventData['userId'] !== undefined) {

      this.configModel?.userId$.set(eventData['userId']);
    }

    if(eventData['isSee'] !== null && eventData['isSee'] !== undefined) {
      this.configModel?.isSee$.set(eventData['isSee']);
    }
    if(eventData['userType'] !== null && eventData['userType'] !== undefined) {
      this.configModel?.userType$.set(eventData['userType']);
    }
    if(eventData['enableTooltip'] !== null && eventData['enableTooltip'] !== undefined) {
      this.configModel?.enableTooltip$.set(eventData['enableTooltip']);
    }
    if(eventData['userRoles'] !== null && eventData['userRoles'] !== undefined) {
      this.configModel?.userRoles$.set(eventData['userRoles']);
    }
    if(eventData['size'] !== null && eventData['size'] !== undefined) {
      this.configModel?.size$.set(eventData['size']);
    }
    this.initialize();
  }

  private createUserInitials(firstName: string, lastName: string): string {
    if(!firstName && !lastName) {
      return '??';
    }
    else if(!firstName) {
      return lastName.trim().charAt(0);
    }
    else if(!lastName) {
      return firstName.trim().charAt(0);
    }
    else {
      return firstName.trim().charAt(0) + lastName.trim().charAt(0);
    }
  }

  private resolveUserType(isSee: boolean, userRoles: Array<string>): string {
    if(!isSee) {
      return 'external';
    }
    else {
      if(!userRoles) {
        return 'see-other';
      }
      else {
        if(userRoles.indexOf('solution_center_see_') > -1 || userRoles.indexOf('r_d_seed_see_') > -1) {
          return 'see-sc-and-dd';
        }
        else {
          return 'see-other';
        }
      }
    }
  }


  protected isDefaultAvatar(): string {
    return '';
  }

  protected isDefaultFirstName(): string {
    return '';
  }
  protected isDefaultLastName(): string {
    return '';
  }
  protected isDefaultUserId(): number | null {
    return null;
  }

  protected isDefaultisSee(): boolean | null {
    return null;
  }
  protected isDefaultUserRoles(): Array<string> | null{
    return null;
  }

  protected isDefaultEnableTooltip(): boolean{
    return true;
  }

  protected isDefaultUserType() : string| null {
    return null;
  }

  protected isDefaultUserInitials() : string| null {
    return null;
  }

  protected isDefaultSize() : number {
    return 40;
  }

}
